<template>
  <BaseModal
    dataClass="error-modal"
    size="md"
    :title="columnInfos.error.label"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:main>
      <b-alert show variant="danger">
        {{ message }}
      </b-alert>
    </template>
    <template v-slot:footer="{ cancel }">
      <!-- はいボタン -->
      <BaseButton
        variant="primary"
        :columnInfo="columnInfos.yes"
        @click="cancel"
      />
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: 'ErrorModal',

  inheritAttrs: false,

  props: {
    /**
     * 項目定義情報.
     * @type {Object}
     */
    columnInfos: {
      type: Object,
      required: true,
    },

    /**
     * メッセージ.
     * @type {String}
     */
    message: {
      type: String,
      default: '',
    },
  },
}
</script>
